class Age {
  private static _values: Age[] = [];
  private static _lookup: Map<number, Age> = new Map();

  static fromTag(id: number) {
    const age = Age._lookup.get(id);
    if (age === undefined) {
      throw new Error('Not a valid Age.id: ' + id);
    }
    return age;
  }

  static values(): Age[] {
    return [...Age._values];
  }

  static fromId(id: number): Age {
    const age = Age._lookup.get(id);
    if (age === undefined) {
      throw new Error('Not a valid Age.id: ' + id);
    }
    return age;
  }

  static size(): number {
    return Age._values.length;
  }

  // ---

  public readonly id: number;
  public readonly label: string;

  constructor(id: number, label: string) {
    this.id = id;
    this.label = label;
    Age._values.push(this);
    Age._lookup.set(id, this);
  }

  hasPrevious(): boolean {
    return this.id > -2;
  }

  getPrevious(): Age {
    return Age.fromId(this.id - 1);
  }

  hasNext(): boolean {
    return this.id < 80;
  }

  getNext(): Age {
    return Age.fromId(this.id + 1);
  }

  toString() {
    return '<Age: ' + this.id + ", label='" + this.label + "'>";
  }
}

// Fill ages
(() => {
  new Age(-2, 'Fetus');
  new Age(-1, 'Neonate');
  new Age(0, 'Infant');
  for (let i = 1; i < 80; i++) {
    new Age(i, '' + i);
  }
  new Age(80, '80+');
})();

export { Age };
